module.exports = __webpack_public_path__ + "static/media/user.e086c247.svg";